module.exports = __webpack_public_path__ + "img/[咖啡].44b06593.svg";